
import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/RedboxNEF.css';

const RedboxNEF = () => {
  return (
    <>
      <Helmet>
        <title>Redbox NEF | Redbox Global</title>
        <meta
          name="description"
          content="Redbox New Economic Forum (NEF) insights on global economic policy, innovation, sustainable growth, and strategic leadership."
        />
        <meta
          name="keywords"
          content="Redbox NEF, New Economic Forum, global economy, economic policy, sustainable development, leadership summit, Redbox Global"
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/nef" />
        <meta property="og:title" content="Redbox NEF | Redbox Global" />
        <meta
          property="og:description"
          content="Strategic insights from the Redbox New Economic Forum on global growth, innovation, and governance."
        />
        <meta
          property="og:image"
          content="https://images.unsplash.com/photo-1503424886307-b090341d25d1?w=1200&h=630&fit=crop"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Redbox NEF | Redbox Global" />
        <meta
          name="twitter:description"
          content="Economic leadership insights from the Redbox New Economic Forum."
        />
        <meta
          name="twitter:image"
          content="https://images.unsplash.com/photo-1503424886307-b090341d25d1?w=1200&h=630&fit=crop"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/nef" />
      </Helmet>

      <div className="page-container">
        <div className="page-header">
          <h1>Redbox NEF</h1>
          <p className="page-subtitle">
            Insights from the Redbox New Economic Forum on global growth and leadership
          </p>
        </div>

        <div className="page-content">

          {/* Featured Article */}
          <a
            href="/article/nef-global-growth-agenda-2026"
            style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
          >
            <div className="featured-article">
              <div className="featured-image">
                <img
                  src="https://images.unsplash.com/photo-1503424886307-b090341d25d1?w=1200&h=600&fit=crop"
                  alt="Global economic summit"
                />
              </div>
              <div className="featured-content">
                
                <h2>The 2026 Global Growth Agenda: Innovation, Stability, Sustainability</h2>
                <p>
                  Leaders at the Redbox NEF outline strategic priorities for economic resilience,
                  technological transformation, and sustainable development.
                </p>
                <span className="article-meta">February 11, 2026</span>
              </div>
            </div>
          </a>

          {/* Article Grid */}
          <div className="content-grid">

            <a
              href="/article/nef-digital-economy-forum"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=600&h=400&fit=crop"
                    alt="Digital economy discussion"
                  />
                </div>
                <div className="article-content">
                 
                  <h2>Shaping the Future of the Digital Economy</h2>
                  <p>
                    Policy makers and industry leaders debate regulation, AI innovation,
                    and digital infrastructure expansion.
                  </p>
                  <span className="article-meta">February 8, 2026</span>
                </div>
              </article>
            </a>

            <a
              href="/article/nef-sustainable-finance-summit"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600&h=400&fit=crop"
                    alt="Sustainable finance summit"
                  />
                </div>
                <div className="article-content">
               
                  <h2>Financing the Green Transition: Global Investment Priorities</h2>
                  <p>
                    The role of private capital and public-private partnerships in accelerating
                    climate-focused economic transformation.
                  </p>
                  <span className="article-meta">February 6, 2026</span>
                </div>
              </article>
            </a>

            <a
              href="/article/nef-emerging-markets-dialogue"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1492724441997-5dc865305da7?w=600&h=400&fit=crop"
                    alt="Emerging markets panel"
                  />
                </div>
                <div className="article-content">
                  
                  <h2>Emerging Markets and the Next Decade of Growth</h2>
                  <p>
                    Strategic reforms and investment flows shaping high-growth economies
                    in Africa, Asia, and Latin America.
                  </p>
                  <span className="article-meta">February 3, 2026</span>
                </div>
              </article>
            </a>

          </div>

        </div>
      </div>
    </>
  );
};

export default RedboxNEF;
